import { createContext } from 'react';

import type { StringTranslations } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

const StringsContext = createContext<StringTranslations>({});

export default StringsContext;
